import { render, staticRenderFns } from "./pamongKeluarga.vue?vue&type=template&id=d19c4b06&scoped=true&"
import script from "./pamongKeluarga.vue?vue&type=script&lang=js&"
export * from "./pamongKeluarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c4b06",
  null
  
)

export default component.exports